import _ from 'lodash'

export default {
  methods: {

    /** 
       * Faz um busca para saber se o termo tem a ver com o produto.
       * @param product - Objecto produto, contendo pelo menos os atributos id e nome, caso lookEan=true precisa ter ean
       * @param searchTerms - Array de String com os termos a serem buscados.
       * @param lookEan (opcional) - Booleano para indicar se deve ser buscado o valor no atributo EAN do produto.
       * @returns Numero inteiro com o score negativo ou zero. Quando menor o score melhor e o resultado da busca.
       * score 0 representa que o termo nao tem a ver com o produto.
       */
    classificatePriorityMatch(product, searchTerms, lookEan) {

      let productName = product.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      let score = 0;
      
      for (let x = 0; x < searchTerms.length; x++) {
        let term = searchTerms[x]
        let indexOf = productName.indexOf(term)

        // Caso de palavras curtas (2 letras) o match tem q ser exato.
        if (term.length == 2) {
          if (indexOf !== -1) {
            if (productName.match(new RegExp('\\b' + term + '\\b'))) {
              score -= 800
              score -= Math.abs(100 - indexOf)
            }
          }
        } if (term.length > 2) {
          // Encontrando as palavras pra dar o match
          if (indexOf !== -1) {
            if (productName.match(new RegExp('^' + term + '\\b'))) {
              score -= 1000
            } else if (productName.match(new RegExp('\\b' + term + '\\b'))) {
              score -= 800
            } else if (productName.match(new RegExp('\\b' + term))) {
              score -= 700
            } else {
              score -= 500
            }
            score -= Math.abs(100 - indexOf)
          }

          // Faz a busca considerando o EAN do produto.
          
          if (lookEan && product.ean) {
            let normalizedEan = product.ean.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            let eanScore = normalizedEan.indexOf(term)
            if (eanScore != -1) {
              score -= normalizedEan.length - eanScore
            }
          }
        }
      }
      return score;
    },

    /**
     * @param productList - Lista de produtos com id, name e ean quando lookEan for true
     * @param typedSearchTerm String com o termo a ser buscado
     * @param maxListSize Numero inteiro com o maximo a ser filtrado
     * @param lookEan boolean para indicar se a busca deve considerar o parametro ean do produto na busca
     * @returns Objeto com indexList e productList
     *  > indexList - Lista de string dos ids 
     *  > productList - Lista dos objetos contendo id,nome,ean e priority
     */
    filterIndexedProduct(productList, typedSearchTerm, maxListSize, lookEan, autoRemoveItem) {
      let searchTerm = _.clone(typedSearchTerm)
      let products = _.clone(productList)

      let terms = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ')
      products = products.filter((product) => {
        product.priority = this.classificatePriorityMatch(product, terms, lookEan)
        if (autoRemoveItem === undefined || autoRemoveItem === true) {
          return product.priority != 0
        } else {
          product.removeFlag = (product.priority == 0)
          return true
        }
      })

      // Ordena e faz splice antes de enviar para o servidor
      products = products.sort((a, b) => {
        return a.priority - b.priority
      })
      if (maxListSize && maxListSize != -1) {
        products = products.slice(0, maxListSize)
      }
      let indexArray = products.map((m) => m.id)
      return {
        indexList: indexArray,
        productList: products
      }
    },

    matchAndSortByPriority(productIndexList, productList) {
      for (let x = 0; x < productList.length; x++) {
        productIndexList.find((element) => {
          let result = element.id == productList[x].id;
          productList[x].priority = element.priority
          return result
        })
      }
      // Ordena lista de acordo com as prioridades
      productList.sort((a, b) => {
        return a.priority - b.priority
      })
      return productList
    }
  }
}